/*! @pentacode/ui v0.1.0 */
import { b as e, d as t, f as n, g as r, l as i, m as a, p as o, v as s, w as c, x as l } from "./guide-layout-CrWsmVuf.js";
import { _ as u } from "./shared-D0HMDGlg.js";
import { a as d, i as f } from "./rule-D2ufK5oT.js";
//#region ../../node_modules/.pnpm/internmap@2.0.3/node_modules/internmap/src/index.js
var p = class extends Map {
	constructor(e, t = _) {
		if (super(), Object.defineProperties(this, {
			_intern: { value: /* @__PURE__ */ new Map() },
			_key: { value: t }
		}), e != null) for (let [t, n] of e) this.set(t, n);
	}
	get(e) {
		return super.get(m(this, e));
	}
	has(e) {
		return super.has(m(this, e));
	}
	set(e, t) {
		return super.set(h(this, e), t);
	}
	delete(e) {
		return super.delete(g(this, e));
	}
};
function m({ _intern: e, _key: t }, n) {
	let r = t(n);
	return e.has(r) ? e.get(r) : n;
}
function h({ _intern: e, _key: t }, n) {
	let r = t(n);
	return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function g({ _intern: e, _key: t }, n) {
	let r = t(n);
	return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function _(e) {
	return typeof e == "object" && e ? e.valueOf() : e;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/range.js
function v(e, t, n) {
	e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
	for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, a = Array(i); ++r < i;) a[r] = e + r * n;
	return a;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/ordinal.js
var y = Symbol("implicit");
function b() {
	var e = new p(), t = [], n = [], r = y;
	function i(i) {
		let a = e.get(i);
		if (a === void 0) {
			if (r !== y) return r;
			e.set(i, a = t.push(i) - 1);
		}
		return n[a % n.length];
	}
	return i.domain = function(n) {
		if (!arguments.length) return t.slice();
		t = [], e = new p();
		for (let r of n) e.has(r) || e.set(r, t.push(r) - 1);
		return i;
	}, i.range = function(e) {
		return arguments.length ? (n = Array.from(e), i) : n.slice();
	}, i.unknown = function(e) {
		return arguments.length ? (r = e, i) : r;
	}, i.copy = function() {
		return b(t, n).unknown(r);
	}, u.apply(i, arguments), i;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/band.js
function x() {
	var e = b().unknown(void 0), t = e.domain, n = e.range, r = 0, i = 1, a, o, s = !1, c = 0, l = 0, d = .5;
	delete e.unknown;
	function f() {
		var e = t().length, u = i < r, f = u ? i : r, p = u ? r : i;
		a = (p - f) / Math.max(1, e - c + l * 2), s && (a = Math.floor(a)), f += (p - f - a * (e - c)) * d, o = a * (1 - c), s && (f = Math.round(f), o = Math.round(o));
		var m = v(e).map(function(e) {
			return f + a * e;
		});
		return n(u ? m.reverse() : m);
	}
	return e.domain = function(e) {
		return arguments.length ? (t(e), f()) : t();
	}, e.range = function(e) {
		return arguments.length ? ([r, i] = e, r = +r, i = +i, f()) : [r, i];
	}, e.rangeRound = function(e) {
		return [r, i] = e, r = +r, i = +i, s = !0, f();
	}, e.bandwidth = function() {
		return o;
	}, e.step = function() {
		return a;
	}, e.round = function(e) {
		return arguments.length ? (s = !!e, f()) : s;
	}, e.padding = function(e) {
		return arguments.length ? (c = Math.min(1, l = +e), f()) : c;
	}, e.paddingInner = function(e) {
		return arguments.length ? (c = Math.min(1, e), f()) : c;
	}, e.paddingOuter = function(e) {
		return arguments.length ? (l = +e, f()) : l;
	}, e.align = function(e) {
		return arguments.length ? (d = Math.max(0, Math.min(1, e)), f()) : d;
	}, e.copy = function() {
		return x(t(), [r, i]).round(s).paddingInner(c).paddingOuter(l).align(d);
	}, u.apply(f(), arguments);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/rect-radius-state-internal.js
function S(e) {
	return e?.some(({ style: e }) => {
		let t = e.radius;
		return typeof t == "function" || Array.isArray(t);
	}) ?? !1;
}
function C(e, t) {
	return e === void 0 ? t ? { cornerRadii: [
		0,
		0,
		0,
		0
	] } : {} : typeof e == "number" ? t ? { cornerRadii: [
		e,
		e,
		e,
		e
	] } : { radius: e } : { cornerRadii: e };
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scene-motion-internal.js
var w = /* @__PURE__ */ Symbol("scene-motion-node");
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/stack-ends-internal.js
function T(e, t, n, r, i, a = {}, o = "value") {
	let s = O(e, t, n, r, i, o), c = k(s, a.order);
	a.reverse && c.reverse();
	let u = new Map(c.map((e, t) => [l(e), t])), d = [...s].sort((e, t) => u.get(l(e.series)) - u.get(l(t.series))), f = Array.from({ length: e.length }), p = E(s), m = E(d), h = a.offset === void 0 || a.offset === "diverging";
	for (let [e, t] of m) {
		let n = p.get(e);
		if (h) {
			let e = Math.min(...t.flatMap((e) => [e.start, e.end]));
			Math.max(...t.flatMap((e) => [e.start, e.end])) > 0 && D(t, n, "max", f), e < 0 && D(t, n, "min", f);
		} else {
			let e = t[0].start, r = t.at(-1).end, i;
			if (r < e) i = "min";
			else if (r > e) i = "max";
			else {
				let n = Math.min(...t.flatMap((e) => [e.start, e.end])), r = Math.max(...t.flatMap((e) => [e.start, e.end]));
				i = e - n > r - e ? "min" : "max";
			}
			D(t, n, i, f);
		}
	}
	return f;
}
function E(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		if (n.value === 0 || n.start === n.end) continue;
		let e = l(n.position), r = t.get(e);
		r ? r.push(n) : t.set(e, [n]);
	}
	return t;
}
function D(e, t, n, r) {
	if (e.length === 0) return;
	let i = Math[n](...e.flatMap((e) => [e.start, e.end]));
	for (let e of t) {
		let t = e.start === i, n = e.end === i;
		if (!t && !n) continue;
		let a = r[e.index];
		r[e.index] = {
			start: a?.start === !0 || t,
			end: a?.end === !0 || n
		};
	}
}
function O(e, t, n, r, i, a) {
	let o = [];
	for (let s = 0; s < e.length; s += 1) {
		let c = e[s], l = t[s], u = r[s], d = i[s];
		if (!j(c) || !M(l) || !M(u) || !M(d)) continue;
		let f = n[s];
		o.push({
			index: s,
			position: c,
			value: l,
			start: u,
			end: d,
			series: A(f) ? f : a === "index" ? s : "value"
		});
	}
	return o;
}
function k(e, t) {
	let n = [], r = /* @__PURE__ */ new Set();
	for (let t of e) {
		let e = l(t.series);
		r.has(e) || (r.add(e), n.push(t.series));
	}
	if (Array.isArray(t)) {
		let e = [...t], r = new Set(e.map(l));
		return [...e, ...n.filter((e) => !r.has(l(e)))];
	}
	if (t === "inside-out") {
		let t = [], r = /* @__PURE__ */ new Map();
		for (let n of e) {
			let e = l(n.position);
			r.has(e) || (r.set(e, t.length), t.push(n.position));
		}
		let i = n.map((n) => {
			let i = l(n), a = t.map(() => [0, 0]);
			for (let t of e) l(t.series) === i && (a[r.get(l(t.position))][1] = t.value);
			return a;
		});
		return d(i).map((e) => n[e]);
	}
	if (t !== "ascending" && t !== "descending") return n;
	let i = new Map(n.map((e) => [l(e), 0]));
	for (let t of e) {
		let e = l(t.series);
		i.set(e, (i.get(e) ?? 0) + Math.abs(t.value));
	}
	return n.sort((e, n) => {
		let r = (i.get(l(e)) ?? 0) - (i.get(l(n)) ?? 0);
		return t === "ascending" ? r : -r;
	});
}
function A(e) {
	return typeof e == "string" || typeof e == "number";
}
function j(e) {
	return typeof e == "string" || M(e) || e instanceof Date && Number.isFinite(e.getTime());
}
function M(e) {
	return typeof e == "number" && Number.isFinite(e);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/bar.js
function N(c, u = {}) {
	let d = Array.isArray(c) ? c : Array.from(c), p = u.xScale ?? "x", m = u.yScale ?? "y", h = typeof u.radius == "function" || S(u.states);
	return t(({ markIndex: t }) => {
		let c = u.id ?? `bar-y-${t}`, g = i(d, u.x, (e, { index: t }) => t), _ = H(d, u.y ?? u.y2, (e) => typeof e == "number" ? e : void 0), v = i(d, u.z, () => null), y = u.color === void 0 ? v : i(d, u.color, () => null), b = u.z === void 0 && u.color !== void 0 ? y : v, x = u.y1 !== void 0 || u.y2 !== void 0;
		if (x && u.layout?.type === "stack") throw TypeError("A bar with explicit y1 or y2 endpoints cannot also configure a stack layout");
		let S = u.layout?.type === "group";
		P(u.radius, x, S, "y");
		let C = u.layout?.type === "stack" ? u.layout : void 0, E = I(u.radius) ? u.radius : void 0, D = C?.offset === void 0 || C.offset === "diverging", O = !x && !S ? f(g, _, b, C, "index") : void 0, k = O && E && (E.stack ?? "outer") === "outer" ? T(g, _, b, O.starts, O.ends, C, "index") : void 0, A = x ? H(d, u.y1, () => 0) : O?.starts ?? d.map(() => 0), j = x ? H(d, u.y2 ?? u.y, () => void 0) : S ? _ : O.ends, M = B(g), N = S || !x && M ? b : v, L = n(d, u.key, {
			groups: N,
			candidates: [g],
			markId: c,
			warningIdentity: u
		});
		return {
			id: c,
			states: r(d, u.states),
			seriesFromColor: u.z === void 0 && u.color !== void 0 && (S || M),
			channels: {
				x: {
					scale: p,
					values: g.filter(o)
				},
				y: {
					scale: m,
					values: [...j.filter(a), ...A.filter(a)],
					includeZero: u.y1 === void 0
				},
				color: {
					scale: "color",
					values: y.filter(e)
				}
			},
			render: ({ scales: e, chart: t, color: n }) => {
				let r = e[p].bandwidth || V(e[p], g, t.width, d.length), i = z(u.layout?.type === "group" ? u.layout : void 0, N, r), f = i?.bandwidth ?? r, v = R(f, u.inset, u.maxThickness), b = [];
				return d.forEach((t, x) => {
					let S = g[x], C = _[x], T = A[x], E = j[x];
					if (!o(S) || !a(C) || !a(T) || !a(E)) return;
					let M = N[x] ?? null, P = i?.map(M) ?? 0, I = n(y[x]), R = s(u.fill, t, x, d, I), z = s(u.stroke, t, x, d, "none"), B = s(u.strokeDasharray, t, x, d, "none"), V = e[p].map(S), H = e[m].map(T), U = e[m].map(E), W = O && D && C < 0 ? "start" : "end", G = W === "start" ? H : U, K = W === "start" ? U : H, q = k?.[x], J = V - r / 2 + P + v.inset, Y = Math.min(H, U), X = v.size, Z = Math.abs(H - U), Q = `${c}:${l(M)}:${l(L[x])}`, $ = F(u.radius, t, x, d, "y", G, K, k !== void 0, q, H, U, h), ee = {
						key: Q,
						markId: c,
						group: M,
						groupLabel: M == null ? c : String(M),
						datum: t,
						datumIndex: x,
						xValue: S,
						yValue: C,
						y1Value: T,
						y2Value: E,
						yInterval: "difference",
						x: V - r / 2 + P + f / 2,
						y: G,
						color: R
					}, te = {
						kind: "rect",
						key: Q,
						x: J,
						y: Y,
						width: X,
						height: Z,
						...$,
						inset: v.inset,
						insetAxis: "x",
						...v.maximum === void 0 ? {} : { maxThickness: v.maximum },
						interaction: {
							point: ee,
							affinity: "x"
						},
						style: {
							fill: R,
							fillOpacity: u.fillOpacity,
							stroke: z,
							strokeOpacity: u.strokeOpacity,
							strokeWidth: u.strokeWidth,
							strokeDasharray: B
						},
						[w]: { bar: { baseline: K } }
					};
					b.push(te);
				}), { nodes: [{
					kind: "group",
					key: c,
					className: "ts-chart__bar ts-chart__bar-y",
					ariaHidden: !0,
					children: b
				}] };
			}
		};
	}, u.motion, u.renderer);
}
function P(e, t, n, r) {
	if (I(e) && e.stack === "outer") {
		if (t) throw TypeError(`Bar radius stack "outer" requires an implicit ${r} extent`);
		if (n) throw TypeError("Bar radius stack \"outer\" cannot be used with a group layout");
	}
}
function F(e, t, n, r, i, a, o, c, l, u, d, f) {
	if (e === void 0) return C(void 0, f);
	if (I(e)) {
		let f = s(e.end, t, n, r, 0);
		if (a === o) return { cornerRadii: [
			0,
			0,
			0,
			0
		] };
		if (c) {
			if (!l) return { cornerRadii: [
				0,
				0,
				0,
				0
			] };
			if (l.start && l.end) return { cornerRadii: [
				f,
				f,
				f,
				f
			] };
			let e = l.start;
			return { cornerRadii: L(f, i, e ? u : d, e ? d : u) };
		}
		return { cornerRadii: L(f, i, a, o) };
	}
	return C(s(e, t, n, r, 0), f);
}
function I(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function L(e, t, n, r) {
	return t === "y" ? n <= r ? [
		e,
		e,
		0,
		0
	] : [
		0,
		0,
		e,
		e
	] : n <= r ? [
		e,
		0,
		0,
		e
	] : [
		0,
		e,
		e,
		0
	];
}
function R(e, t, n) {
	let r = Math.max(0, t ?? 0), i = Math.max(0, e), a = Math.max(0, i - r * 2), o = Number.isFinite(n), s = o ? Math.max(0, n) : a, c = Math.min(a, s);
	return {
		inset: (i - c) / 2,
		maximum: o ? s : void 0,
		size: c
	};
}
function z(e, t, n) {
	if (!e) return;
	let r = c(e.scale ?? (() => x().padding(Number.isFinite(e.padding) ? Math.max(0, e.padding) : .1)), { values: t });
	r.range([0, n]);
	let i = r.bandwidth?.();
	if (i === void 0) throw TypeError("A grouped bar layout requires a D3 band scale");
	return {
		bandwidth: i,
		map(e) {
			if (e === null) throw TypeError("A grouped bar requires an explicit z channel or a discrete color channel");
			let t = r(e);
			if (t === void 0 || !Number.isFinite(t)) throw TypeError(`Bar group value "${String(e)}" is outside the group layout scale domain`);
			return t;
		}
	};
}
function B(e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) {
		if (!o(n)) continue;
		let e = l(n);
		if (t.has(e)) return !0;
		t.add(e);
	}
	return !1;
}
function V(e, t, n, r) {
	let i = [...new Set(t.filter(o).map(e.map).filter((e) => Number.isFinite(e)))].sort((e, t) => e - t), a = Infinity;
	for (let e = 1; e < i.length; e += 1) a = Math.min(a, i[e] - i[e - 1]);
	return Number.isFinite(a) ? a * .8 : Math.min(48, n / Math.max(2, r + 1) * .8);
}
function H(e, t, n) {
	return typeof t == "number" ? e.map(() => t) : i(e, t, n);
}
//#endregion
export { N as t };

//# sourceMappingURL=bar-COFxhm37.js.map